export const clearClosedCollapsibles = (html: string) => {
  const parser = new DOMParser()
  const doc = parser.parseFromString(html, 'text/html')
  const details = doc.querySelectorAll('details[open="false"]')
  details.forEach(detail => {
    detail.removeAttribute('open')
  })
  return doc.documentElement.innerHTML
}
